import { Injectable } from '@angular/core';
import { HttpClient } from './http-client';
import { BaseEntityService } from './baseentity-service';
import {AcopioViewModel} from '@utils/ViewModels';

@Injectable()
export class CategoriaService extends BaseEntityService {
  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  responseItemToEntity(responseItem: any): any {
    return {
      ID: responseItem.Id,
      Categoria: responseItem.CategoriaNombre,
      Acopios: responseItem.Acopios
    };
  }

  apiRoute: string = '/api/roles/categorias/';
}

export interface CategoriaZona {
  ID: number,
  Categoria: string,
  Acopios: AcopioViewModel[]
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/categoria-service.ts